import http from "../utils/http-common";

const baseStatusPath = "api/status";

export const getYear = () => {
  return http.get(`${baseStatusPath}/year`);
};

export const getSummaryApproval = (query: string) => {
  return http.get(`${baseStatusPath}/summary/approval?${query}`);
};

export const getOptions = (query: string) => {
  return http.get(`${baseStatusPath}/approval/filter-option?${query}`);
};

export const getApprovalById = (query: string) => {
  return http.get(`${baseStatusPath}/approval/data?${query}`);
};

export const resendMailApproval = (data: any) => {
  return http.post(`${baseStatusPath}/approval/resend-mail`, data);
};

export const updateApproveReport = (companyId: string, menuName: string, data: any) => {
  return http.post(`${baseStatusPath}/approval/report/approve-voc-emission/${companyId}/${menuName}`, data);
};
